import * as assignmentAPI from '@adobe/edex/frontend/api/assignment';
import * as abuseAPI from '@adobe/edex/frontend/api/abuse';

const assignment = {
  namespaced: true,
  state: {
    assignment: null,
    loading: false,
  },
  mutations: {
    set(state, assignment) {
      state.assignment = assignment;
      state.loading = false;
    },
    setLoading(state, loading = true) {
      state.loading = loading;
    },
    resetState(state) {
      state.assignment = null;
      state.loading = false;
    },
  },
  actions: {
    async createAssignment({ commit, state }, payload) {
      commit('setLoading');
      const { status, data } = await assignmentAPI.create(payload);
      if (status === 201) {
        commit('set', data);
      }
    },
    async updateAssignment({ commit, state }, payload) {
      commit('setLoading');
      const { status, data } = await assignmentAPI.update(payload);
      if (status === 200) {
        commit('set', data);
      }
    },
    async requestChanges({ commit, state }, id) {
      commit('setLoading');
      const { status, data } = await assignmentAPI.requestChanges(id);
      if (status === 200) {
        commit('set', data);
      }
    },
    async fetchAssignment({ commit, state }, id) {
      commit('setLoading');
      const { status, data } = await assignmentAPI.get(id);
      if (status === 200) {
        commit('set', data);
      }
    },
    async resetAssignment({ commit }) {
      commit('resetState');
    },
    async deleteAssignment({ commit, state }, { id, courseID }) {
      commit('setLoading');
      await assignmentAPI.remove(id, courseID);
      commit('resetState');
    },
    async flagAssignment({ commit, state }, id) {
      commit('setLoading');
      await abuseAPI.create(id, 'Assignment');
      commit('setLoading', false);
    },
    async unflagAssignment({ commit, state }, id) {
      commit('setLoading');
      await abuseAPI.remove(id, 'Assignment');
      commit('setLoading', false);
    },
  },
};

export default assignment;
